import { Routes } from '@angular/router';
import { PublicPage } from './public.page';
import { importProvidersFrom } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { PublicState } from '@public/state';

export const routes: Routes = [
    {
        path: '',
        component: PublicPage,
        providers: [importProvidersFrom([NgxsModule.forFeature([PublicState])])],
        children: [
            {
                path: '',
                loadComponent: () => import('@public/views/activities/activities.page').then((m) => m.ActivitiesPage),
            },
            {
                path: 'boka/:uuid',
                loadComponent: () => import('@public/views/booking/booking.page').then((m) => m.BookingPage),
            },
            {
                path: 'aktivitet/:uuid',
                loadComponent: () => import('@public/views/activity/activity.page').then((m) => m.ActivityPage),
            },
            {
                path: 'aktivitet/:uuid/filer',
                loadComponent: () => import('@public/views/activity/activity-files/activity-files.page').then((m) => m.ActivityFilesPage),
            },
            // Keep this route for backwards compatibility
            {
                path: 'form/:uuid',
                loadComponent: () => import('@public/views/activity/activity.page').then((m) => m.ActivityPage),
            },
            {
                path: 'snabbguide',
                loadComponent: () => import('@public/views/quickguide/quickguide.page').then((m) => m.QuickguidePage),
            },
            {
                path: 'forms',
                loadChildren: () => import('@public/views/forms/routes').then((m) => m.routes),
            },
            {
                path: 'foretags-information',
                loadComponent: () =>
                    import('@public/views/information-pages/company-information/company-information.page').then(
                        (m) => m.CompanyInformationPage,
                    ),
            },
            {
                path: 'guider',
                loadComponent: () => import('@public/views/information-pages/about-guide/about-guide.page').then((m) => m.AboutGuidePage),
            },
            {
                path: 'om-guidningar',
                loadComponent: () =>
                    import('@public/views/information-pages/guiding-rules/guiding-rules.page').then((m) => m.GuidingRulesPage),
            },
            {
                path: 'reseinformation',
                loadComponent: () =>
                    import('@public/views/information-pages/travel-information/travel-information.page').then(
                        (m) => m.TravelInformationPage,
                    ),
            },
            {
                path: 'om-oss',
                loadComponent: () => import('@public/views/information-pages/about-us/about-us.page').then((m) => m.AboutUsPage),
            },
        ],
    },
];
